import download_file from "frontend/files/actions/download_file"
import component from "frontend/legacy/unavailable-message"
import navigate from "frontend/routes/navigate"
import { defineComponent } from "vue"

export default defineComponent({
  extends: component,
  props: ["imposition_url"],
  methods: {
    initial_action() {
      download_file(this.imposition_url.replace(/\/json\//g, "/pdf/"))
      navigate()
    },
  },
})
